export { breedsSchema as schema } from '../../pets/schema';
